export const menu_list = [
  { text: 'Работы YARO', path: `/my-works` },
  // { text: 'Выставка', path: `/gallery/cabinet` },
];
